import fetchResource from '../utils/fetchResource'
import {User} from '../providers/UserContext'

export default function fetchMe(): Promise<User> {
  return fetchResource<User>('/api/users/me')
}
